













































import { Prop, Component, Vue } from "vue-property-decorator";
import { Company, Office } from "@/api/company-api";
import VSearchBar from "@/components/VSearchBar.vue";

@Component({
  components: {
    VSearchBar
  }
})
export default class EndUserShow extends Vue {
  @Prop({ required: true }) company!: Company;
  @Prop({ required: true }) office!: Office;
  query: string = "";
}
